export default "__VITE_ASSET__1ba394f3__"